import {HttpService} from './../http-service';
import {ConfigService} from './../config-service';

//import { NativeStorage } from '@ionic-native/native-storage';
import {Injectable} from '@angular/core';
import {RequestOptions, Headers} from '@angular/http';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class LoginProvider {
  private _url: string;
  private _client_id: string;
  private _client_secret: string;
  private _baseApi: string = '/oauth/token/';

  //private nativeStorage: NativeStorage;

  constructor(public http: HttpService,
              // private _nativeStorage: NativeStorage,
              private _configService: ConfigService,
  ) {

    //this.nativeStorage  = _nativeStorage;
    this._url = this._configService.url;
    this._client_id = this._configService.client_id;
    this._client_secret = this._configService.client_secret;
  }

  /**
   * Gera token de acesso para o usuário
   * Atenção: Esse método não está carregando as informações do usuário, para isso use {UserProvider.getUserAuth}
   */
  fazerLogin(login: { usuario: string, senha: string }) {
    let _options = new RequestOptions({headers: new Headers({'Content-Type': 'application/json'})});
    let api = `${this._baseApi}`;
    let self = this;

    let body = JSON.stringify({
      username: login.usuario,
      password: login.senha,
      client_id: this._client_id,
      client_secret: this._client_secret,
      grant_type: 'password'
    });

    return new Promise((success, reject) => {
      let _success = success;
      let _reject = reject;
      self.http.post(api, this._url, body, _options)
        .map(res => res.json())
        .toPromise()
        .then((data) => {
          localStorage.removeItem('currentUser');
          localStorage.removeItem('token');

          localStorage.setItem('token', data.access_token);

          _success(data);
      }).catch(function (err) {
        let retorno = JSON.parse(err._body);
        _reject(retorno.message);
      });

    });
  }

  logout() {
    let api = '/logout';
    let self = this;

    let body = JSON.stringify({
      client_id: this._client_id,
      client_secret: this._client_secret
    });

    return new Promise((success, reject) => {
      let _success = success;
      let _reject = reject;
      self.http.post(api, this._url, body)
        .map(res => res.json())
        .toPromise().then((data) => {
          this._clearState();
          _success(data);
      }).catch((err) => {
        try {
          let retorno = JSON.parse(err._body);
          _reject(retorno);
        } catch (e) {
          console.error('Falha ao transformar o _body em JSON: ', err._body);
          _reject(new Error('Não foi possível fazer logout'));
        }
      });
    });
  }

  hasAccessToken() {
    return !!localStorage.getItem('token');
  }

  _clearState() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    localStorage.removeItem('userData');

    // TODO: Verificar se devemos limpar o evento aberto
    localStorage.removeItem('evento_aberto');
  }

}



// WEBPACK FOOTER //
// ./src/providers/login/login.provider.ts